import React from 'react';
import { Button } from './ui/button';
import haircolor from "../assets/images/haircolor.jpg";

const HairColour = () => {
  return (
    <div className="pt-20">
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Hair Colour Services</h1>
              <p className="text-gray-700 leading-relaxed mb-4">
                Before developing the ideal colour for you, we provide professional consultation and heed to all your color needs while analyzing your skin tone, eye colour, and hair texture.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                From subtle highlights to bold transformations, our expert colorists bring your vision to life.
              </p>
              <Button
                className="bg-black hover:bg-gray-800 text-white px-8 py-4 rounded-full"
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Book Appointment
              </Button>
            </div>
            <div>
              <img src={haircolor} alt="Hair Colour" className="rounded-lg shadow-xl w-full h-[500px] object-cover" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HairColour;
